export var LAYOUT_TYPE_PINBOARD = 0;
export var LAYOUT_TYPE_CLASSIC = 1;
export var LAYOUT_TYPE_COMPACT = 2;
//# sourceMappingURL=layout-types.js.map